<div class="row">
  <div class="col-sm-12">
    <div class="card card-border">
      <div class="card-header">
        <div class="form-group row mb-2">
          <div *ngIf="idSprNivelN5 !=idSprNivel" class="col col-md-12">
            <span><b>LÍNEA DE ACCIÓN: </b>{{ nameLineaAccion }}</span>
          </div>
          <div *ngIf="idSprNivelN5 ==idSprNivel" class="col col-md-12">
            <span><b>PLAN DE ACCIÓN: </b>{{ namePlanAccion }}</span>
          </div>

        </div>
      </div>
      <!-- TABLA -->
      <div class="container card-body table-responsive">
        <div class="row mb-2">
          <div class="col-sm-6 text-sm-right">
            <div *ngIf=" nombreElemento == 'modalPlanAccion'">
              <div *hasDenied="{nivel:idSprNivel, app: constant.PLANES_ACCION}">
              <button *hasPermission="{app: constant.PLANES_ACCION,permission: [constant.CREAR, constant.CREAR]}" type="button" class="btn btn-sm btn-success waves-effect" (click)="openModalActividad()">
                <i class="fas fa-plus fa-lg mr-1"></i> Nuevo
              </button>
            </div>
            </div>
          </div>
            <div *ngIf=" nombreElemento == 'modalLineaAccion'">
              <div *hasDenied="{nivel:idSprNivel, app: constant.LINEAS_ACCION}">
            <button *hasPermission="{app: constant.LINEAS_ACCION,permission: [constant.CREAR, constant.CREAR]}" type="button" class="btn btn-sm btn-success waves-effect" (click)="openModalActividad()">
              <i class="fas fa-plus fa-lg mr-1"></i> Nuevo
            </button>
            </div>
          </div>
        </div>

        <table class="table table-striped table-bordered row-border hover">
          <thead>
            <tr>
              <th>Nro.</th>
              <th>Actividad</th>
              <th>Fecha Comprometida</th>
              <th>Peso</th>
              <th>Cumplimiento</th>
              <th>Semáforo</th>
              <th>Fecha de Cumplimiento</th>
              <th class="text-center">Documento de soporte</th>
              <th>Estado</th>
              <th>Seguimiento</th>
              <th>Acción</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of listaActividadesN5; let indice = index">
              <!-- <td>{{row.idSprActividad}}</td> -->
              <td>{{ indice + 1 }}</td>
              <td>{{ row.nombre }}</td>
              <td>{{ row.fechaComprometida | date: 'dd-MM-yyyy'}}</td>
              <td>{{ row.peso }} %</td>
              <td *ngIf="row.cumplimiento == 1">
                <p class="text-success text-center col-sm-auto">SI</p>
              </td>
              <td *ngIf="row.cumplimiento == 1">
                <p class="text-center col-sm-auto">
                  <i class="fa fa-circle m-r-20 fa-lg" style="color: green"></i>
                </p>
              </td>
              <td *ngIf="row.cumplimiento == 2">
                <p class="text-danger text-center col-sm-auto">NO</p>
              </td>
              <td *ngIf="row.cumplimiento == 2">
                <p class="text-center col-sm-auto">
                  <i class="fa fa-circle m-r-10 fa-lg" style="color: red"></i>
                </p>
              </td>
              <td *ngIf="row.cumplimiento == null">
                <p class="text-danger text-center col-sm-auto">NO</p>
              </td>
              <td *ngIf="row.cumplimiento == null">
                <p class="text-center col-sm-auto">
                  <i class="fa fa-circle m-r-10 fa-lg" style="color: red"></i>
                </p>
              </td>
              <td>
                <div *ngIf="row.cumplimiento != null">
                  {{ row.fecha | date : "dd-MM-yyyy" }}
                </div>
              </td>
              <td class="plan-column" style="max-width: 300px; word-wrap: break-word; white-space: normal;">
                <div *ngIf="row.cumplimiento != null">
                  <div class="row">
                    <!-- <button type="button" tooltip="Visualizar pdf respaldo"
                  class="btn btn-sm btn-link waves-effect rounded-pill" title="Documento de soporte"
                  (click)="visualizarPdf(row.respaldo)">
                  <i class="fas fa-file-pdf fa-lg"></i>
                </button> -->
                    <button type="button" tooltip="Visualizar pdf respaldo"
                      class="btn btn-sm btn-link waves-effect rounded-pill" title="Documento de soporte"
                      (click)="visualizarPdf(row.respaldo)">
                      <i class="fas fa-file-pdf fa-lg"></i>
                      <div class="text-center">
                        <span (click)="visualizarPdf(row.respaldo)">{{row.respaldo}}</span>
                      </div>
                    </button>
                  </div>
                </div>
              </td>

              <td>{{ row.estado == "1" ? "Activo" : "Inactivo" }}</td>

              <td class="text-center">
                <button tooltip="Editar" class="btn btn-sm btn-link waves-effect rounded-pill" title="Evaluación"
                  (click)="evaluacionActividades(row)">
                  <i class="fas fa-chart-line fa-lg"></i>
                </button>
              </td>


              <td class="text-center ">
                  <div class="row">
                    <div *ngIf=" nombreElemento == 'modalLineaAccion'">
                      <div class="row" *hasDenied="{nivel:idSprNivel, app: constant.LINEAS_ACCION}">
                      <button *hasPermission="{app: constant.LINEAS_ACCION, permission: [constant.ACTUALIZAR]}"
                      type="button" tooltip="Editar" class="btn btn-sm btn-link waves-effect rounded-pill col px-0"
                      title="Editar este registro" (click)="updateActividades(row)">
                      <i class="fas fa-pencil-alt fa-lg"></i>
                      </button>
                      <button *hasPermission="{app: constant.LINEAS_ACCION, permission: [constant.BORRAR]}" type="button"
                        class="btn btn-sm btn-link waves-effect col px-0" title="Eliminar este registro"
                        (click)="deleteActividades(row.idSprActividad)">
                        <i class="fas fa-trash-alt fa-lg"></i>
                        </button>
                      </div>
                    </div>

                    <div *ngIf=" nombreElemento == 'modalPlanAccion'">
                      <div class="row" *hasDenied="{nivel:idSprNivel, app: constant.PLANES_ACCION}">
                    <button *hasPermission="{app: constant.PLANES_ACCION, permission: [constant.ACTUALIZAR]}"
                    type="button" tooltip="Editar" class="btn btn-sm btn-link waves-effect rounded-pill col px-0"
                    title="Editar este registro" (click)="updateActividades(row)">
                    <i class="fas fa-pencil-alt fa-lg"></i>
                    </button>
                    <button *hasPermission="{app: constant.PLANES_ACCION, permission: [constant.BORRAR]}" type="button"
                      class="btn btn-sm btn-link waves-effect col px-0" title="Eliminar este registro"
                      (click)="deleteActividades(row.idSprActividad)">
                      <i class="fas fa-trash-alt fa-lg"></i>
                      </button>
                    </div>
                  </div>

                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- TABLA FIN -->

    <!-- MENSAJE DE ELIMINAR -->
    <jw-modal id="deleteActivities">
      <div class="modal-dialog" style="padding-top: 15%">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="myCenterModalLabel">Advertencia!</h4>
            <button type="button" class="btn-close" (click)="modal.close()"></button>
          </div>
          <div class="modal-body">
            <p class="pl-4">
              <i class="pl-2 fas fa-exclamation-circle text-warning fa-lg fa-2x"></i>&nbsp;
              &nbsp; Esta seguro que desea eliminar este registro?
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary waves-effect" (click)="closeModalEliminar()">
              Cancelar
            </button>
            <button type="button" class="btn btn-primary" (click)="confirmDelete()">
              Si, borrar!
            </button>
          </div>
        </div>
      </div>
    </jw-modal>

    <!-- MENSAJE DE ELIMINAR FIN -->

    <!-- MODAL PARA CREAR Y EDITAR -->
    <jw-modal id="{{ modalActividades }}">
      <div class="modal-dialog modal-lg" style="margin-top: 120px" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title">{{ nameActivadadesPlanes }}</h3>
            <button type="button" class="btn-close" (click)="closeModalActividad()" aria-label="Close"></button>
          </div>
          <div class="card mb-1">
            <div class="card-body pT-4">
              <form class="needs-validation" novalidate id="formPlanAccion" id="formActividad"
                [formGroup]="formActividad" autocomplete="off" (ngSubmit)="onSubmit()">
                <div class="form-group row mb-2">
                  <div class="col col-md-2 text-md-right">
                    <label for="nombre" class="form-control-label text-md-right pt-1"><b>Actividad:</b></label>
                  </div>
                  <div class="col-12 col-md-10">
                    <input type="hidden" id="nombre" formControlName="nombre" requiered class="is-invalid" />

                    <textarea type="text" class="form-control" required="true" formControlName="nombre" maxlength="1500"
                      rows="3" cols="30"
                      [ngClass]="{ 'is-invalid': this.formActividad.get('nombre')?.errors && this.formSubmitted,'is-valid': !this.formActividad.get('nombre')?.errors,}"
                      [disabled]="desahabilitarForm" [readonly]="desahabilitarForm">
                    </textarea>

                    <!--<small class="font-italic"-->
                    <small class="invalid-feedback"
                      *ngIf="this.formActividad.get('nombre')?.errors?.['required'] && this.formSubmitted">Campo
                      requerido</small>
                  </div>
                </div>

                <div class="form-group row mb-2"></div>

                <div class="form-group row mb-2">
                  <div class="col col-md-2 text-md-right">
                    <label for="peso" class="form-control-label text-md-right pt-1"><b>Peso
                        actividad:</b></label>
                  </div>
                  <div class="col-12 col-md-4">
                    <input type="number" min="0" max="100" maxlength="3" onkeydown="return false" name="peso" id="peso"
                      placeholder="Solo caracteres Numericos" class="form-control" required autocomplete="off"
                      onkeypress="return(event.charCode>= 48 && event.charCode <= 57)" formControlName="peso" required
                      autofocus placeholder="peso"
                      [ngClass]="{'is-invalid': this.formActividad.get('peso')?.errors && this.formSubmitted,'is-valid': !this.formActividad.get('peso')?.errors, }"
                      [disabled]="desahabilitarForm" [readonly]="desahabilitarForm" />
                    <small class="invalid-feedback"
                      *ngIf="this.formActividad.get('peso')?.errors?.['required'] && this.formSubmitted">Campo
                      requerido</small>
                  </div>
                  <div *ngIf="editPorcentajeTotal" class="col col-md-2 text-md-right">
                    <label for="calificacion" class="form-control-label text-md-right pt-1"><b>Porcentaje
                        restante
                        (%):</b>
                    </label>
                  </div>
                  <div *ngIf="editPorcentajeTotal" class="col-12 col-md-4">
                    <input class="form-control" disabled style="background-color: #e9e8e8"
                      placeholder="{{ pesoRestante }} %" />
                  </div>

                  <div *ngIf="editPorcentaje" class="col col-md-2 text-md-right">
                    <label for="calificacion" class="form-control-label text-md-right pt-1"><b>Porcentaje
                        restante.
                        (%):</b>
                    </label>
                  </div>
                  <div *ngIf="editPorcentaje" class="col-12 col-md-4">
                    <input class="form-control" disabled style="background-color: #f5f4f4"
                      placeholder="{{ pesoTotalEditado }} %" />
                  </div>
                </div>

                <div class="form-group row mb-4">
                  <div class="col col-md-2 text-md-right">
                    <label for="fechaComprometida" class="form-control-label text-md-right pt-1"><b>Fecha
                        Comprometida:</b></label>
                  </div>
                  <div class="col-12 col-md-4">
                    <input type="date" class="form-control" required="true" placeholder="fecha Comprometida"
                      formControlName="fechaComprometida"
                      [ngClass]="{ 'is-invalid': this.formActividad.get( 'fechaComprometida')?.errors && this.formSubmitted, 'is-valid':!this.formActividad.get( 'fechaComprometida')?.errors,} " />

                    <!--<input type="date" class="form-control" required="true" placeholder="fechaComprometida"
                      formControlName="fechaComprometida"
                      [ngClass]="{'is-invalid': this.formActividad.get('fechaComprometida')?.errors && this.formSubmitted,'is-valid': !this.formActividad.get('fechaComprometida')?.errors, }"
                      [disabled]="desahabilitarForm" date [readonly]="desahabilitarForm" />-->
                    <small class="invalid-feedback"
                      *ngIf="this.formActividad.get('fechaComprometida')?.errors?.['required'] && this.formSubmitted">Campo
                      requerido</small>
                    <div class="col text-danger">
                      <span class="font-italic" *ngIf="
                          this.formActividad.get('fechaComprometida').errors
                            ?.fechaInicio
                        ">La fecha debe estar comprendida entre
                        {{
                        this.formActividad.get("fechaComprometida")?.errors
                        .fechaInicio
                        }}
                        y
                        {{
                        this.formActividad.get("fechaComprometida")?.errors
                        .fechaFin
                        }}
                      </span>
                    </div>
                  </div>
                  <div class="col col-md-2 text-xl-right">
                    <label for="estado" class="form-control-label text-md-right pt-1"><b>Estado:</b></label>
                  </div>
                  <div class="col-12 col-md-4">
                    <select id="estado" class="form-select" formControlName="estado" required
                      [ngClass]="{'is-invalid': this.formActividad.get('estado')?.errors && this.formSubmitted,'is-valid': !this.formActividad.get('estado')?.errors, }"
                      [disabled]="desahabilitarForm">
                      <option [value]="item.value" *ngFor="let item of selectItems">
                        {{ item.label }}
                      </option>
                    </select>
                    <small class="invalid-feedback"
                      *ngIf="this.formActividad.get('estado')?.errors?.['required'] && this.formSubmitted">Campo
                      requerido</small>
                  </div>
                </div>
                <div class="modal-footer" id="modal">
                  <button type="button" class="btn btn-secondary waves-effect" data-dismiss="modal"
                    (click)="closeModalActividad()">
                    Cerrar
                  </button>

                  <button type="submit" class="btn btn-info">Guardar</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </jw-modal>

    <jw-modal id="{{ modalCumpleActividades }}">
      <div class="modal-dialog modal-lg" style="margin-top: 120px" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title">{{ nameActivadades }}</h3>
            <button type="button" class="btn-close" (click)="closeModalCumpleActividad()" aria-label="Close"></button>
          </div>
          <div class="card mb-1">
            <div class="card-body px-5">
              <form class="needs-validation was-validated" novalidate id="formPlanAccion" id="formActividadCumple"
                [formGroup]="formActividadCumple" autocomplete="off">
                <div class="container card-body mb-2 table-responsive" style="
                    background-color: #f2f3f4;
                    border-radius: 20px;
                    border: 1px solid #d3d4d6;
                    box-shadow: 2px 2px 5px #999;
                  ">
                  <div class="form-group row mb-2">
                    <div class="col col-md-3">
                      <b><span style="text-align: right; display: block">Acción:</span></b>
                    </div>
                    <div class="col col-md-8">
                      <span>{{ nombre }}</span>
                    </div>
                  </div>

                  <div class="form-group row mb-2">
                    <div class="col col-md-3">
                      <b><span style="text-align: right; display: block">Fecha
                          comprometida:</span></b>
                    </div>
                    <div class="col col-md-3">
                      <span>{{ fechaComprometida  | date : "dd-MM-yyyy" }}</span>
                    </div>
                    <div class="col col-md-3">
                      <b><span style="text-align: right; display: block">Fecha
                          Cumplimiento:</span></b>
                    </div>
                    <div class="col col-md-3">
                      <span>{{ fechaInicio  | date : "dd-MM-yyyy"}}</span>
                    </div>
                  </div>
                  <div class="form-group row mb-2">
                    <div class="col col-md-3">
                      <b><span style="text-align: right; display: block">Peso
                          actividad:</span></b>
                    </div>
                    <div class="col col-md-3">
                      <span>{{ peso }} %</span>
                    </div>
                  </div>
                </div>

                <div class="shadow-sm p-2 mb-2 bg-white rounded py-0">
                  <h3 class="text-center py-0">CUMPLIMIENTO</h3>
                </div>
                <div class="form-group row mb-2">
                  <div class="col col-md-2 text-md-right">
                    <label for="respaldo" class="form-control-label text-md-right pt-1"><b>Respaldo
                        pdf:</b></label>
                  </div>
                  <div class="col-12 col-md-12">
                    <input #myInput type="file" class="form-control" id="respaldo" formControlName="respaldo"
                      required="true" (change)="capturarFile($event)"
                      [ngClass]="{'is-invalid': this.formActividadCumple.get('respaldo')?.errors && this.formSubmitted,'is-valid': !this.formActividadCumple.get('respaldo')?.errors,}" />
                    <small class="invalid-feedback"
                      *ngIf="this.formActividadCumple.get('respaldo')?.errors?.['required'] && this.formSubmitted">Campo
                      requerido</small>
                  </div>
                </div>
                <div class="form-group row mb-2"></div>
                <div class="modal-footer" id="modal">
                  <button type="button" class="btn btn-secondary waves-effect" data-dismiss="modal"
                    (click)="closeModalCumpleActividad()">
                    Cerrar
                  </button>

                  <button type="button" class="btn btn-info" (click)="subirArchivo()">
                    Guardar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </jw-modal>
  </div>
</div>